export default __webpack_public_path__ + "static/charts-person-d54542b9cd9024f2417cbf310530fec5.png";